import { render, staticRenderFns } from "./MonsterImmunities.vue?vue&type=template&id=d13e7d0a&scoped=true&"
import script from "./MonsterImmunities.vue?vue&type=script&lang=ts&"
export * from "./MonsterImmunities.vue?vue&type=script&lang=ts&"
import style0 from "./MonsterImmunities.vue?vue&type=style&index=0&id=d13e7d0a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d13e7d0a",
  null
  
)

export default component.exports